import { Input } from "antd";
import * as React from "react";

type PropsInputNumberOrString = {
  value?: number | string;
  onChange?: (newValue: number | string) => void;
  allowClear?: boolean;
  title?: string;
};

export const InputNumberOrString: React.FC<PropsInputNumberOrString> = (
  props,
) => {
  const { value, onChange, allowClear, title } = props;
  const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    const text = e.currentTarget.value.trim();
    const newValue = /^\d+$/.test(text) ? +text : text;
    onChange?.(newValue);
  };
  const textValue = value === null || value === undefined ? "" : String(value);
  return (
    <Input
      value={textValue}
      onChange={handleChange}
      allowClear={allowClear}
      title={title}
    />
  );
};
